'use client';

import { formatCurrency } from '@ahm/common-helpers';
import { rem, ScrollArea, Table } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

export function ListCOD() {
  const tBooking = useTranslations('booking');
  const isMobile = useIsMobile();
  const { serviceTypes } = useBookingStore((state) => state);

  const rows = useMemo(() => {
    if (!serviceTypes) return [];

    return serviceTypes.map((element) => (
      <Table.Tr key={element._id} mih={rem(36)}>
        <Table.Td align="left">{element.name}</Table.Td>
        <Table.Td align="left">
          {formatCurrency(element.max_cod_per_stop_point) ?? '--'}
        </Table.Td>
        <Table.Td align="left">
          {formatCurrency(element.max_cod) ?? '--'}
        </Table.Td>
      </Table.Tr>
    ));
  }, [serviceTypes]);

  return (
    <ScrollArea h={isMobile ? 400 : 200} scrollbars="y">
      <Table
        striped="even"
        stripedColor="var(--mantine-color-neutral-1)"
        highlightOnHover
        stickyHeader
        withRowBorders={false}
        mah={isMobile ? 400 : 200}
      >
        <Table.Thead
          style={{
            borderBottom: `1px solid var(--mantine-color-neutral-3)`,
            color: 'var(--mantine-color-neutral-5)',
            fontWeight: 700,
          }}
        >
          <Table.Tr>
            <Table.Th align="left">
              {tBooking('location.modal_learn_about_cod_column_service_name')}
            </Table.Th>
            <Table.Th align="left">
              {tBooking(
                'location.modal_learn_about_cod_column_cod_each_stop_point'
              )}
            </Table.Th>
            <Table.Th align="left">
              {tBooking('location.modal_learn_about_cod_column_total_cod')}
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody
          style={{
            color: 'var(--mantine-color-neutral-7)',
            fontSize: rem(12),
            lineHeight: rem(16),
            fontWeight: 600,
          }}
        >
          {rows}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  );
}
